/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  MVP_M365_COPILOT_BENEFIT_BASE_URL,
  RD_M365_COPILOT_BENEFIT_BASE_URL,
} from "Constants/SagaConstants";
import { IM365CopilotBenefitSearchRequest } from "Interfaces/Benefits/IM365CopilotBenefitSearchRequest";
import { IM365CopilotBenefitSearchResponse } from "Interfaces/Benefits/IM365CopilotBenefitSearchResponse";
import { IApiResult2 } from "Interfaces/IApiResult";

import { post, IHttpResponse } from "./ApiUtils";

/**
 * Search MVP M365 Copilot Benefit
 * @param requestBody for searching M365 Copilot benefits
 * @returns {Promise<IHttpResponse<IApiResult2<IM365CopilotBenefitSearchResponse>>>}
 */
export async function searchMvpM365CopilotBenefit(
  requestBody: IM365CopilotBenefitSearchRequest
): Promise<IHttpResponse<IApiResult2<IM365CopilotBenefitSearchResponse>>> {
  const url = MVP_M365_COPILOT_BENEFIT_BASE_URL + "/search";
  return await post<IApiResult2<IM365CopilotBenefitSearchResponse>>(url, requestBody, true);
}

/**
 * Search RD M365 Copilot Benefit
 * @param requestBody for searching M365 Copilot benefits
 * @returns {Promise<IHttpResponse<IApiResult2<IM365CopilotBenefitSearchResponse>>>}
 */
export async function searchRdM365CopilotBenefit(
  requestBody: IM365CopilotBenefitSearchRequest
): Promise<IHttpResponse<IApiResult2<IM365CopilotBenefitSearchResponse>>> {
  const url = RD_M365_COPILOT_BENEFIT_BASE_URL + "/search";
  return await post<IApiResult2<IM365CopilotBenefitSearchResponse>>(url, requestBody, true);
}
